export const MAIN_STACK_SIZE_SM = 'calc(100vh - 112px)';
export const MAIN_STACK_SIZE_MD = 'calc(613px - 48px)';
export const NEW_MODAL_MAX_HEIGHT = '613px';
export const NEW_MODAL_MAX_WIDTH = '1137px';
export const NEW_MODAL_GLOBAL_PADDING = '24px';
